import { Property } from 'csstype'
import styled from 'styled-components'

export const StyledStatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 400;
`

interface StyledBadgeProps {
  $color?: Property.BackgroundColor
}

export const StyledBadge = styled.span<StyledBadgeProps>`
  height: 10px;
  width: 10px;
  border-radius: 5px;

  ${({ $color }) => $color && `
    background-color: ${$color}
  `}
`
